import PropTypes from 'prop-types';
import clsx from 'clsx';
import Icon from '@/components/Icon';
import Link from '@/components/Link';

const defaultProps = {
  link: '',
  icon: '',
  children: null,
};

const propTypes = {
  link: PropTypes.string,
  icon: PropTypes.string,
  children: PropTypes.node,
};

export default function Card({
  link,
  icon,
  children,
}) {
  const hasLink = link !== '';
  const hasIcon = icon !== '';

  let content = (
    <div className="flex flex-col md:flex-row md:space-x-6 lg:space-x-8">
      {hasIcon && (
        <div className="w-full pt-4 pl-8 md:pt-0 md:pl-0 md:w-28 rounded-l-lg lg:rounded-l-xl xl:rounded-l-2xl flex items-center md:justify-center relative">
          <div className="relative z-10 w-20 text-green-500 md:ml-5">
            <Icon name={icon} />
          </div>
          <div className="absolute inset-0 w-full md:w-3/4 bg-gradient-to-b from-green-100 to-white z-0" />
        </div>
      )}
      <div className="flex-1 pt-3 pb-8 md:py-10 px-8 md:px-0">
        {children}
      </div>
    </div>
  );

  if (hasLink) {
    content = (
      <Link href={link}>
        {content}
      </Link>
    );
  }

  return (
    <div
      className={clsx(
        'flex bg-white shadow-lg hover:shadow-outside-lg rounded-lg lg:rounded-xl xl:rounded-xl overflow-hidden relative',
        hasLink && 'relative transform transition-all ease-in-out duration-500 hover:-translate-y-1',
      )}
    >
      {content}
    </div>
  );
}

Card.defaultProps = defaultProps;
Card.propTypes = propTypes;
